/* @flow */
import { reaction, observable } from 'mobx';

import UserStore from 'stores/UserStore';
import { customerUsers, internalUsers } from 'permissions/userTypes';

export default class HotjarService {
  userStore: UserStore;

  @observable hjLoaded = false;

  constructor(userStore: UserStore) {
    this.userStore = userStore;

    this.registerHjLoadedListener();
    this.initialise();
  }

  initialise() {
    reaction(
      () => this.userStore.activeUser && this.userStore.userLoaded && this.hjLoaded,
      (ready: boolean) => {
        if (ready && window.hj) {
          const { id, role_id, role_name, accounts } = this.userStore.activeUser;

          let role_group = null;
          if (internalUsers.includes(role_id)) {
            role_group = 'Internal';
          } else if (customerUsers.includes(role_id)) {
            role_group = 'Customer';
          }

          window.hj('identify', id, {
            role_id,
            role_name,
            role_group,
            trading_account_numbers: accounts.map(account => account.account_no),
            trading_account_names: accounts.map(account => account.name),
          });
        }
      }
    );
  }

  handleHjLoaded = () => {
    this.hjLoaded = true;
  };

  registerHjLoadedListener() {
    window.addEventListener('hjTagLoaded', this.handleHjLoaded);
  }
}
